module.exports = __webpack_public_path__ + "3d9105770ca78b4a67f5087d7abacab2.svg";